import { AnyFieldMeta } from '@tanstack/react-form';
import { ZodError } from 'zod';

type FieldErrorsProps = {
	meta: AnyFieldMeta;
};

export const FieldErrors = ({ meta }: FieldErrorsProps) => {
	if (!meta || !meta.isTouched) return null;

	const seen = new Set<string>();
	return meta.errors
		.filter((e: ZodError) => {
			const msg = e?.message ?? '';
			if (seen.has(msg)) return false;
			seen.add(msg);
			return true;
		})
		.map(({ message }: ZodError, index) => (
			<p key={index} className="help help-error">
				{message}
			</p>
		));
};